var React = require('react');

function IconArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.6766 0.928941L26.0406 7.2929C26.4311 7.68343 26.4311 8.31659 26.0406 8.70712L19.6766 15.0711C19.2861 15.4616 18.653 15.4616 18.2624 15.0711C17.8719 14.6806 17.8719 14.0474 18.2624 13.6569L22.9193 9.00001L1.3335 9.00001C0.781211 9.00001 0.333496 8.55229 0.333496 8.00001C0.333496 7.44772 0.781211 7.00001 1.3335 7.00001L22.9193 7.00001L18.2624 2.34315C17.8719 1.95263 17.8719 1.31947 18.2624 0.928941C18.653 0.538416 19.2861 0.538416 19.6766 0.928941Z","fill":"#001D3B"}));
}

IconArrowRight.defaultProps = {"width":"27","height":"16","viewBox":"0 0 27 16","fill":"none"};

module.exports = IconArrowRight;

IconArrowRight.default = IconArrowRight;
